const handleErrors = (response: Response) => {
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response;
};

export const fetchJson = <TResponse>(endpoint: string, params?: URLSearchParams) => {
    const url = new URL(endpoint, window.location.origin);
    if (params) {
        params.forEach((value, key) => url.searchParams.set(key, value));
    }

    return fetch(url.toString(), {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    })
        .then(handleErrors)
        .then((response) => response.json() as Promise<TResponse>);
};

export const fetchJsonPost = <TResponse, TPayload = unknown>(url: string, payload?: TPayload) =>
    fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload && JSON.stringify(payload),
    })
        .then(handleErrors)
        .then((response) => response.json() as Promise<TResponse>);
